export type PasswordStrength = 'weak' | 'fair' | 'strong';

export const PASSWORD_STRENGTH_LEVELS: PasswordStrength[] = ['weak', 'fair', 'strong'];

export type PasswordRule = 'length' | 'capital' | 'number' | 'symbol';

/** The rules a password must all meet to count as strong — the bar the UI requires before submitting. */
export const PASSWORD_RULES: Record<PasswordRule, (password: string) => boolean> = {
  length: (password) => password.length >= 8,
  capital: (password) => /[A-Z]/.test(password),
  number: (password) => /\d/.test(password),
  symbol: (password) => /[^a-zA-Z\d]/.test(password),
};

/** Strong once all four rules are met (8+ characters, a capital letter, a number, a symbol); fair from two. */
export function getPasswordStrength(password: string): PasswordStrength {
  const met = Object.values(PASSWORD_RULES).filter((rule) => rule(password)).length;
  if (met === Object.keys(PASSWORD_RULES).length) return 'strong';
  return met >= 2 ? 'fair' : 'weak';
}

/**
 * Client-side only — the sign-up and reset forms block submit on it; Firebase's own policy is what the
 * server enforces.
 */
export function isStrongPassword(password: string): boolean {
  return getPasswordStrength(password) === 'strong';
}
